import { render } from "./PasswordChangeBanner.vue?vue&type=template&id=0ad2e1e3&scoped=true"
import script from "./PasswordChangeBanner.vue?vue&type=script&lang=js"
export * from "./PasswordChangeBanner.vue?vue&type=script&lang=js"

import "./PasswordChangeBanner.vue?vue&type=style&index=0&id=0ad2e1e3&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad2e1e3"]])

export default __exports__